// ===== Packages =====

import {
    doc,
    getFirestore,
    onSnapshot,
    Unsubscribe,
}                               from 'firebase/firestore';

// ===== Interfaces =====

import {
    IAnnotationEngagementItem,
}                               from '../interfaces';

// ===== Enums =====

import {
    FIRESTORE_COLLECTION,
}                               from '../enums';

const subscribeToAnnotationEngagementItems = ({
    test,
    annotationIds,
    onNext,
}: {
    test: boolean,
    annotationIds: string[],
    onNext: (annotationEngagementItems: Map<string, IAnnotationEngagementItem>) => void,
}): Unsubscribe => {
    const firestore = getFirestore();
    const annotationEngagementCollection = test
        ? FIRESTORE_COLLECTION.stagingAnnotationEngagement
        : FIRESTORE_COLLECTION.annotationEngagement;
    const listeners: Unsubscribe[] = [];
    const currentItems = new Map<string, IAnnotationEngagementItem>();

    const emit = (): void => {
        onNext(new Map(currentItems));
    };

    if (annotationIds.length === 0) {
        emit();
        return () => undefined;
    }

    annotationIds.forEach((annotationId) => {
        listeners.push(onSnapshot(
            doc(firestore, annotationEngagementCollection, annotationId),
            (snapshot) => {
                if (!snapshot.exists()) {
                    currentItems.delete(annotationId);
                    emit();
                    return;
                }
                currentItems.set(annotationId, snapshot.data() as IAnnotationEngagementItem);
                emit();
            },
            () => {
                currentItems.delete(annotationId);
                emit();
            },
        ));
    });

    return () => {
        listeners.forEach((unsubscribe) => unsubscribe());
    };
};

export default subscribeToAnnotationEngagementItems;
